<template>
        <span
        class="text-success">
        <i
            class="fa fa-check-square-o fa-lg icon-button mr-1"
            title="Aprovar Conformidade Técnica"
            @click.stop="confirmarAprovacaoTecnica()"
        ></i>
        </span>
</template>

<script>

export default {
    props: {
        pleito: {
            type: Object
        },

        servicos: {
            type: Object
        },
    },

    methods: {
        confirmarAprovacaoTecnica() {
            this.$swal({
                title: 'Aprovar Conformidade Técnica do Pleito',
                html: `Confirma a <strong>APROVAÇÃO DA CONFORMIDADE TÉCNICA</strong> do pleito <b>${this.pleito.descritivo}</b>?`,
                icon: 'success',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
            }).then(result => {
                if (result.value) {
                    this.aprovarConformidadeTecnica()
                }
            })
        },

        aprovarConformidadeTecnica() {
            this.$store.dispatch('addRequest')
            this.servicos.aprovarConformidadeTecnica(this.pleito.pleitoId).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Pleito em Conformidade Técnica!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('listarPleitos')
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },
}

</script>